import React from 'react';

import RegisterForm from '../Blocks/RegisterForm';
import Terms from '../Blocks/Terms';
import Logos from '../Blocks/Logos';


const register = (props) => (
	<div className='page'>

		<Logos />

		<section className='page__section page__section--white'>

			<div className='page__content wrapper wrapper--narrow clearfix'>

				<Terms />

			</div>

		</section>

		<section className='page__section page__section--white'>

			<div className='wrapper wrapper--narrow clearfix'>

				<RegisterForm />

				<p>&nbsp;</p>

			</div>

		</section>

	</div>
);

export default register;


// WEBPACK FOOTER //
// ./src/Pages/Register.js